import { render, staticRenderFns } from "./openVillage.vue?vue&type=template&id=59ea0cab&scoped=true&"
import script from "./openVillage.vue?vue&type=script&lang=js&"
export * from "./openVillage.vue?vue&type=script&lang=js&"
import style0 from "./openVillage.vue?vue&type=style&index=0&id=59ea0cab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ea0cab",
  null
  
)

export default component.exports